import * as React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeActiveTab, getTopbarTabsCount,fetchSearchResultData,resetIndividualTabGlobalSearch } from '../actions/action';
import Icon from '../../../icons';
import Activities from './activities';
import ActivityOwners from './activityOwners';
import Assignees from './assignees';
import Files from './files';
import Notes from './notes';
import WorkkardOwners from './workkardOwners';
import Workkards from './workkards';
import GlobalSearch from "./index";
import * as CommonUtil from '../../../common/util';
import Select from '../../../components/Select';
export class ExpandedGlobalSearch extends React.Component {
    searchExpandedRef;
    constructor(props){
        super(props);
        this.dataPayload={
            skip: 0,
            take: 100,
            isSearch: true,
            sortDir: 'ASC',
            sortBy: 1,
            rows: 100,
            displayCount: 100,
            status: 'workkards',
            _: new Date(),
        };
        this.onTabClick=this.onTabClick.bind(this);
        this.renderTabs=this.renderTabs.bind(this);
        this.state = {
            showResult:false,
            searchString:'',
            isLandscape:false,
            isViewallClicked:false,
            movingTimeout : -1
        }
    }
    componentDidMount(){
       document.addEventListener('keydown', this.handleScrollKeyDown);
       document.addEventListener('keyup',this.handleScrollKeyUp);
        const payload={
            ...this.dataPayload
        };
        payload.key=this.props.searchString;
        this.props.getTopbarTabsCount(payload);        //action function to get tabs count
        this.setState({
            searchString:this.props.searchString
        })
        if(CommonUtil.mobileAndTabletcheck() && window.innerHeight < window.innerWidth){
            this.setState({
                isLandscape:true
            })
        }   
    }
    componentWillUnmount () {
        this.props.onClose();
       document.removeEventListener('keydown', this.handleScrollKeyDown);
       document.removeEventListener('keyup',this.handleScrollKeyUp);
       clearTimeout(this.state.movingTimeout);
    }
    componentDidUpdate(prevProps){              //when we search in expanded search 
        if(this.props.globalSearch.searchString && this.props.globalSearch.searchString.trim().length >0 && ((this.props.globalSearch.searchString!= prevProps.globalSearch.searchString) || this.state.isViewallClicked)){
            this.setState({
                searchString:this.props.globalSearch.searchString,
                isViewallClicked:false
            },()=>{
                const payload={
                    ...this.dataPayload
                };
                payload.key=this.props.globalSearch.searchString;
                this.props.getTopbarTabsCount(payload);
                if(this.props.globalSearch.activeTab != 0){
                    const payload={
                        activeTab:0
                    }
                    this.props.changeActiveTab(payload);
                }
                this.props.resetIndividualTabGlobalSearch({activeTab:0});
            })
        }
    }

    onTabClick(activeTab){
        const payload={
            activeTab:activeTab
        };
        this.props.changeActiveTab(payload);
        this.props.resetIndividualTabGlobalSearch(payload);
        if(activeTab==0){
            const payload={
                ...this.dataPayload
            };
            payload.key=this.state.searchString;
            this.props.fetchSearchResultData(payload);
        }
    }

    renderTabs(){
        const {activeTab} = this.props.globalSearch;
        switch (activeTab) {
            case 0: {
                return (
                    <Workkards organizationId = {this.props.organizationView?.Id} searchString={this.state.searchString} showResult={this.state.showResult}/>
                )
            }

            case 1: {
                return (
                    <Activities searchString={this.state.searchString} showResult={this.state.showResult}/>
                )
            }

            case 2: {
                return (
                    <Notes searchString={this.state.searchString} showResult={this.state.showResult}/>
                )
            }

            case 3: {
                return (
                    <Files searchString={this.state.searchString} showResult={this.state.showResult} />
                )
            }

            case 4: {
                return (
                   <WorkkardOwners searchString={this.state.searchString} showResult={this.state.showResult}/>
                )
            }
            case 5: {
                return (
                    <ActivityOwners searchString={this.state.searchString} showResult={this.state.showResult}/>
                )
            }

            case 6: {
                return (
                    <Assignees searchString={this.state.searchString} showResult={this.state.showResult}/>
                )
            }
            default: {
                return (
                    <Workkards searchString={this.props.searchString} showResult={this.state.showResult}/>
                )
            }
        }
    }

    handleScrollKeyDown=(event)=>{
        if(event.target && event.target.id !== "txtGlobalSearchinput"){
            let value, i;
            switch(event.keyCode)
            {          
                case 40:                         //arrow down
                    value=100; i = 100;
                    break;                  // return false to override default page scrolling on up and down keys
                    
                case 38:                        //arrow up
                    value=-100; i = -100;
                    break;                  // return false to override default page scrolling on up and down keys
            } 
            if (this.state.movingTimeout === -1) {  
                this.scrollFunction(value,i)
            }
        }
    }

    scrollFunction = (value,i) =>{
        let timeOut = setTimeout(this.scrollFunction, 400,value+i,i);
        document.querySelector("#searchResultData #cardScroll") && document.querySelector("#searchResultData #cardScroll").scrollBy(0,value); 
        this.setState({
            movingTimeout : timeOut
        })
    }

    handleScrollKeyUp = () => {
        clearTimeout(this.state.movingTimeout);
        this.setState({
            movingTimeout : -1
        })
    }
  

    renderHeaderText=(activeTab)=>{
        switch(activeTab){
            case 0:
                return 'Workkards'
            case 1:
                return 'Activities'
            case 2:
                return 'Notes'
            case 3:
                return 'Files'   
            case 4:
                return 'Workkard Owners'
            case 5:
                return 'Activity Owners'
            case 6:
                return 'Activity Assignees'
            default:
                return null
        }
    }
    changeShowResult = (value,isViewall = false) => {
        this.setState({
            showResult:value,
            isViewallClicked:isViewall
        })
    }

    render(){
        const {activeTab,Total,counts} = this.props.globalSearch;
        
        const selectTabOptions=[
            {
                label: `Workkards ${'('+counts.Workkard+')'}`,
                value: 0
            },
            {
                label: `Activities ${'('+counts.Activity+')'}`,
                value: 1
            },
            {
                label: `Notes ${'('+counts.Note+')'}`,
                value: 2
            },
            {
                label: `Files ${'('+counts.File+')'}`,
                value: 3
            },
            {
                label: `Workkard Owners ${'('+counts.WorkkardSponsor+')'}`,
                value: 4
            },
            {
                label: `Activity Owners ${'('+counts.ActivitiesOwner+')'}`,
                value: 5
            },
            {
                label: `Activity Assignees  ${'('+counts.ActivitiesAssignee+')'}`,
                value: 6
            }
        ]
        return(
            <React.Fragment>
            <div className="header modalHeaderFixed">
                <div className="headerMain">
                    <div className="modalHeaderccLogo globalSearchccLogo" onClick={()=>{window.location = `/workkards`}}>
                        <a role="button" tabIndex={0}><Icon name="CasheLogo" className="" /></a>
                    </div>
                    <div className="headerLeft">
                        <h2 className="mr alignMiddle flexGrow">
                            Search results
                        </h2>
                    </div>
                    <div className={`globalSearch ${!this.state.isLandscape && CommonUtil.mobileAndTabletcheck() ? 'active':''}`} id="globalSearchdivExpandedView" ref={(node) => {this.searchExpandedRef = node}}>
                        <GlobalSearch searchText={this.props.searchString} searchExpandedRef={this.searchExpandedRef} changeShowResult = {this.changeShowResult}/>
                    </div>
                    <div className="headerRight alignMiddle">
                        <ul className="ml">
                            <li><a role="button" tabIndex={0} className="btn btnGray" onClick={()=>{this.props.onClose()}}><Icon name="close" className="icon iconSmall mr" /> Close</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div className="modalBody" >
                <div className="searchResult">
                    <div className="searchTabHeader alignMiddle">
                        <h2>
                            {
                                !this.state.isLandscape && CommonUtil.mobileAndTabletcheck() ?
                                <>
                                    Search results 
                                </>
                                :
                                <>
                                {this.renderHeaderText(activeTab)} results for <strong>{this.state.searchString}</strong>
                                </>
                            }
                        </h2>
                         <div className={`tabNav${!this.state.isLandscape && CommonUtil.mobileAndTabletcheck() ? 'dropDown':''}`}>
                            {
                                !this.state.isLandscape && CommonUtil.mobileAndTabletcheck() ?
                                <Select 
                                    options={selectTabOptions}
                                    selected={activeTab}
                                    onSelect={(value) => this.onTabClick(value)}
                                    openOnClick={true}
                                    iconName="downArrow"
                                    isOpenRight={true}
                                    styleClass={"white"}
                                />
                                :
                                <div className="tabs">
                                    <ul>
                                        <li onClick={() => {
                                            if(activeTab !=0) 
                                                this.onTabClick(0)
                                            }} >
                                            <a role="button" tabIndex={0} className={activeTab === 0 ? " active" : ''} >Workkards ({counts.Workkard})</a>
                                        </li>
                                        <li onClick={() => {
                                            if(activeTab != 2)
                                                this.onTabClick(2)
                                        }} >
                                            <a role="button" tabIndex={0} className={activeTab === 2 ? " active" : ''}>Notes ({counts.Note})</a>
                                        </li>
                                        <li onClick={() => {
                                            if(activeTab !=1) 
                                                this.onTabClick(1)
                                            }} >
                                            <a role="button" tabIndex={0} className={activeTab === 1 ? " active" : ''}>Activities ({counts.Activity})</a>
                                        </li>
                                        <li onClick={() => {
                                            if(activeTab != 3)
                                                this.onTabClick(3)
                                        }}>
                                            <a role="button" tabIndex={0} className={activeTab === 3 ? " active" : ''}>Files ({counts.File})</a>
                                        </li>
                                        <li onClick={() => {
                                            if(activeTab != 4)
                                                this.onTabClick(4)
                                        }} >
                                            <a role="button" tabIndex={0} className={activeTab === 4 ? " active" : ''}>Workkard Owners ({counts.WorkkardSponsor})</a>
                                        </li>
                                        <li onClick={() => {
                                            if(activeTab != 5)
                                                this.onTabClick(5)
                                        }}>
                                            <a role="button" tabIndex={0} className={activeTab === 5 ? " active" : ''}>Activity Owners ({counts.ActivitiesOwner})</a>
                                        </li>
                                        <li onClick={() => {
                                            if(activeTab != 6)
                                                this.onTabClick(6)
                                        }} >
                                            <a role="button" tabIndex={0} className={activeTab === 6 ? " active" : ''}>Assignees ({counts.ActivitiesAssignee})</a>
                                        </li>
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="searchResultData" id="searchResultData" >
                        {
                            (this.props.globalSearch.activeTab==0 && this.props.globalSearch.isLoading && this.props.globalSearch.workkards.Data.length ==0)?
                            <div className="SkletonRendar scrolArea">
                                {this.renderTabs()}
                            </div>
                            :
                            this.renderTabs()
                        }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    globalSearch: state.header.globalSearch,
    organizationView: state.sessionContextOidc.organizationView,
});

const mapDispatchToProps = (dispatch) => ({
    changeActiveTab:bindActionCreators(changeActiveTab,dispatch),
    getTopbarTabsCount: bindActionCreators(getTopbarTabsCount,dispatch),
    fetchSearchResultData:bindActionCreators(fetchSearchResultData,dispatch),
    resetIndividualTabGlobalSearch:bindActionCreators(resetIndividualTabGlobalSearch,dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExpandedGlobalSearch);